export const formats = {
  percent: (value: number, options?: Intl.NumberFormatOptions) =>
    new Intl.NumberFormat("en-US", {
      style: "percent",
      maximumFractionDigits: 2,
      ...options,
    }).format(value),
  decimal: (value: number, options?: Intl.NumberFormatOptions) =>
    new Intl.NumberFormat("en-US", {
      style: "decimal",
      maximumFractionDigits: 2,
      ...options,
    }).format(value),
  usd: (value: number, options?: Intl.NumberFormatOptions) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
      ...options,
    }).format(value),
  compact: (value: number, options?: Intl.NumberFormatOptions) =>
    new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
      notation: "compact",
      ...options,
    }).format(value),
  compactUsd: (value: number, options?: Intl.NumberFormatOptions) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
      notation: "compact",
      ...options,
    }).format(value),
};
